import { useLang } from './useLang'

/**
 * The RU/EN switch, in one place.
 *
 * It used to show only the language it would switch TO («EN» while russian) —
 * the convention read backwards by exactly the person it served: «кнопка
 * говорит EN, а схема почему-то русская». Now BOTH languages are visible and
 * the ACTIVE one is highlighted: the control states where you are and where a
 * press takes you, and cannot be read wrong in either direction.
 *
 * `lang` on each segment tells a screen reader to pronounce «Русский» with
 * Russian phonemes; the accessible name says what pressing does.
 */
export function LangToggle({
  className = 'btn btn-ghost btn-sm',
  variant = 'short',
}: {
  className?: string
  variant?: 'short' | 'full'
}) {
  const { lang, toggleLang, t } = useLang()

  return (
    <button
      type="button"
      onClick={toggleLang}
      className={`${className} lang-toggle`}
      aria-label={t.a11y.switchLanguage}
      title={t.a11y.switchLanguage}
    >
      <span className={`lang-seg${lang === 'ru' ? ' lang-on' : ''}`} lang="ru">
        {variant === 'full' ? 'Русский' : 'RU'}
      </span>
      <span className="lang-sep" aria-hidden="true">
        ·
      </span>
      <span className={`lang-seg${lang === 'en' ? ' lang-on' : ''}`} lang="en">
        {variant === 'full' ? 'English' : 'EN'}
      </span>
    </button>
  )
}
